import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sign-up-referral-code',
  templateUrl: './sign-up-referral-code.component.html',
  styleUrls: ['./sign-up-referral-code.component.scss']
})
export class SignUpReferralCodeComponent implements OnInit {

  sectionTitle = 'Create You Account'
  SUReffCodeInfo = {
    enterCode: 'Please enter the refferal code provided by your employer or professional advisor.'
  }

  constructor() { }

  ngOnInit() {
  }

}
